module.exports = __webpack_public_path__ + "img/Demetrio-Strimpopulos.25a38d30.png";